import { MindCatalogItem } from "../../models/mind-catalog.model";
import { ProductV2 } from "../../models/product-v2.model";
import {
  buildMindOrderMeta,
  getDisplayPriceCents,
  MIND_ORDER_META_FIELD,
} from "../../utils/mind-price.utils";

export class MindProductMapper {

  static mapItemToProduct(
    item: MindCatalogItem,
    groupId: string,
    categoryTitle?: string
  ): ProductV2 {

    const offerId = String(item.purchasePayload?.product?.id ?? item.id);
    const productType = item.purchasePayload?.product?.type ?? item.type;
    const displayCents = getDisplayPriceCents(item);
    const price = displayCents / 100;
    const mindMeta = buildMindOrderMeta(item);

    return {
      id: Number(offerId),
      uuid: `${offerId}`,
      name: item.displayName ?? '',
      excerpt: item.descriptionHtml ?? '',
      description: item.descriptionHtml ?? '',
      productType: 'MIND' as any,
      billingModel: 'plan',
      sku: productType,
      price,
      salesPrice: price,
      salesPrices: [price],
      currency: 'BRL',
      termsUrl: '',
      terms: '',
      links: [],
      active: true,
      featured: false,
      image: null,
      imageUrl: '',
      imageUuid: '',
      plan: true,
      paymentRecurrence: item.price?.recurrence ?? 'monthly',
      customFields: [
        {
          label: MIND_ORDER_META_FIELD,
          value: JSON.stringify(mindMeta),
          origin: 'mind',
          type: 'json',
          isVariation: false,
        },
      ],
      categories: categoryTitle
        ? [{ uuid: groupId, name: categoryTitle, description: '' }]
        : [],
      tags: mindMeta.tags ?? [],
      variations: [],
      requiredFields: [],
      galleryImages: [],
      link: '',
      deleted: false,
      createdAt: new Date().toISOString()
    };
  }
}
